import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Loading from "components/lodingState/loading";
import * as React from "react";
import { useNavigate } from "react-router-dom";

const HeroImage = React.lazy(() => import("../components/HeroImage"));

export default function LandingPage() {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        backgroundImage: theme.palette.background.gradient,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: { xs: "100vh", md: "auto" },
      }}
    >
      <React.Suspense fallback={<Loading />}>
        <HeroImage />
      </React.Suspense>

      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 2, sm: 3, md: 5 },
          pb: { xs: 2, sm: 3, md: 4 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Stack
          spacing={{ xs: 1, sm: 2, md: 3 }}
          useFlexGap
          sx={{
            width: { xs: "100%", sm: "85%", md: "70%" },
            alignItems: "center",
          }}
        >
          <Typography
            variant={isMobile ? "h3" : isTablet ? "h2" : "h1"}
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              color: theme.palette.text.primary,
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            }}
          >
            Find dit filter
          </Typography>
          <Typography
            variant={isMobile ? "h6" : isTablet ? "h5" : "h4"}
            sx={{
              textAlign: "center",
              color: theme.palette.text.primary,
              fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            }}
          >
            du kan anvende databasen uden konto
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: { xs: "left", sm: "justify" },
              maxWidth: { xs: "100%", sm: "90%", md: "80%" },
              margin: "0 auto",
              lineHeight: 1.5,
              padding: { xs: 1, sm: 2 },
              fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
            }}
          >
            Vi har udviklet markedets mest omfattende database med mere end
            235.000 filtertyper og maskinlister. Avancerede søgefiltre giver dig
            mulighed for at finde præcis det filter, som du er på udkig efter.
            Uanset om det er originale filtre eller erstatningsfiltre. Vi har et
            omfattede lager, og kan levere fra dag til dag til
            konkurrencedygtige priser.
          </Typography>
          <Button
            onClick={() => {
              navigate("/Filters");
            }}
            variant="contained"
            fullWidth={isMobile}
            sx={{
              textAlign: "center",
              width: { xs: "100%", sm: "auto" },
              mt: { xs: 2, sm: 3 },
              mb: { xs: 1, sm: 2 },
              padding: { xs: "10px 15px", sm: "12px 20px" },
              fontSize: { xs: "0.9rem", sm: "1rem" },
              bgcolor: "#424242",
              "&:hover": {
                bgcolor: "#686868",
              },
            }}
          >
            Gå til Shop{" "}
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
